import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import qs from 'query-string';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { resetPassword } from '../actions/api';
import { history } from '../routers/AppRouter';
import AuthLayout, { PasswordRules, passwordIsValid, apiErrorMessage } from './AuthLayout';

const ResetPassword = () => {
  const { code } = qs.parse(useLocation().search);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const mismatch = confirm.length > 0 && confirm !== password;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await resetPassword(code, password, confirm);
      history.push('/');
    } catch (err) {
      const msg = apiErrorMessage(err);
      setError(msg.includes('Incorrect code')
        ? 'This reset link has expired or was already used. Request a new one.'
        : msg);
      setBusy(false);
    }
  };

  if (!code) {
    return (
      <AuthLayout>
        <h2>This link is incomplete</h2>
        <p className="lede">Open the reset link from your email again, or request a new one.</p>
        <div className="auth-links"><Link to="/forgot-password">Request a new link</Link></div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <form onSubmit={onSubmit} noValidate>
        <h2>Set a new password</h2>
        <p className="lede">You’ll be sent back to log in once it’s saved.</p>
        {error && <div className="form-error" role="alert">{error}</div>}
        <TextField label="New password" type="password" autoComplete="new-password" value={password} required autoFocus
          onChange={(e) => setPassword(e.target.value)} />
        <PasswordRules password={password} />
        <TextField label="Confirm new password" type="password" autoComplete="new-password" value={confirm} required
          onChange={(e) => setConfirm(e.target.value)} error={mismatch}
          helperText={mismatch ? 'Passwords don’t match.' : ' '} />
        <Button type="submit" variant="contained" size="large" fullWidth
          disabled={busy || !passwordIsValid(password) || confirm !== password}>
          {busy ? 'Saving…' : 'Save new password'}
        </Button>
        <div className="auth-links">
          <Link to="/forgot-password">Request a new link</Link>
          <Link to="/">Back to log in</Link>
        </div>
      </form>
    </AuthLayout>
  );
};

export default ResetPassword;
